import { Col, Form, Row, Select } from "antd";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getAdminsSelector } from "../Infrastructure/Administrators.reducer";
import { getAdmins, getAdmin } from "../Application/Administrators.business";
import Button from "../../Layout/DesignSystem/Button/Button";
import Admin from "../../Users/Domain/User";

const { Option } = Select;

const styles = {
 
  select: {
    width: "100%",
    minWidth: 320,
  },
};

export default function Searcher() {
  const records = useSelector(getAdminsSelector);
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const onFinish = async ({ id }) => {
    getAdmin(id);
    navigate(`/administrator/${id}`);
  };

  const onReset = () => {
    form.resetFields();
  };

  function onSearch(val) {
    getAdmins({ filter: { q: val, access_level: Admin.ADMIN_ROLES } });
  }

  return (
    <>
    
            <Form
              layout="horizontal"
              form={form}
              onFinish={onFinish}
              onReset={onReset}
            >
              <Row gutter={10}>
                <Col xs={24} xl={12}>
                  <Form.Item style={styles.select} name={"id"} label="Administrador">
                    <Select
                      clearIcon
                      showSearch
                      onSearch={onSearch}
                      placeholder="Selecciona un usuario"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {records?.map((record) => (
                        <Option value={record.id} key={record.id}>
                          {record.usernameForSearcher}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} xl={2}>
                  <Form.Item colon={false}>
                    <Button htmlType="submit" text={"Seleccionar"} />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
       
    </>
  );
}
